import Enum from './Enum';

export default class AdminStatus extends Enum {
  static INTERIM = new AdminStatus('INTERIM', '仮登録');
  static ACTIVE = new AdminStatus('ACTIVE', '利用中');
  static INACTIVE = new AdminStatus('INACTIVE', '利用停止中');
  static ARCHIVED = new AdminStatus('ARCHIVED', 'アーカイブ済');
}
